import { useState, useRef, useCallback, useEffect } from 'react'

const POPUP_HIDE_DELAY = 500

const useClusterPopup = () => {
  const [popupData, setPopupData] = useState(null)
  const popupActiveRef = useRef(false)
  const timerRef = useRef(null)

  const hidePopup = useCallback(() => {
    popupActiveRef.current = false
    setPopupData(null)
  }, [])

  const handleShowClusterPopup = useCallback((clusterEl, cluster) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }

    setPopupData({ clusterEl, cluster })
  }, [])

  const handleClusterMouseLeave = useCallback(() => {
    timerRef.current = setTimeout(() => {
      if (popupActiveRef.current) return

      timerRef.current = null
      hidePopup()
    }, POPUP_HIDE_DELAY)
  }, [hidePopup])

  const handlePopupMouseEnter = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    popupActiveRef.current = true
  }, [])

  const handlePopupMouseLeave = useCallback(() => {
    popupActiveRef.current = false

    timerRef.current = setTimeout(() => {
      timerRef.current = null
      hidePopup()
    }, POPUP_HIDE_DELAY)
  }, [hidePopup])

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return {
    popupData,
    handleShowClusterPopup,
    handleClusterMouseLeave,
    handlePopupMouseEnter,
    handlePopupMouseLeave
  }
}

export default useClusterPopup
